// extracted by mini-css-extract-plugin
export default {"comments":"Comments_comments__zg2Fh"};